import OrderFlowWaiterPage from "./OrderFlowWaiterPage.vue";

export {OrderFlowWaiterPage}
export default OrderFlowWaiterPage
